<template>
  <div class="heads-down">
    <b>You're in Heads Down mode right now.</b> While in this mode, you'll
    accumulate 5,000 snaps every 30 days. You cannot read books or request
    readers while in this mode. When you're ready to resume your activity, you
    can leave Heads Down mode and receive your accumulated snaps.
    <div class="breakdown">
      <div class="breakdown-line">
        <div class="breakdown-label">Started Heads Down:</div>
        <div class="breakdown-value">
          {{ startDate }} ({{ daysAgo }} days ago)
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="breakdown-line">
        <div class="breakdown-label">Accumulated Snaps:</div>
        <div class="breakdown-value">{{ earnedSnaps }} snaps</div>
        <div class="clearfix"></div>
      </div>
      <div class="breakdown-line">
        <div class="breakdown-label">Next Earn Date:</div>
        <div class="breakdown-value">{{ nextDate }}</div>
        <div class="clearfix"></div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="leave-button action grow" @click="clickExit">
      Exit Heads Down Mode
    </div>
    <div class="leave-button-more">
      You will earn {{ earnedSnaps }} snaps if you exit now.
    </div>
  </div>
</template>

<script>
import Back from "../../modules/Back";
export default {
  name: "HeadsDown",
  props: ["date"],
  data: function () {
    return {
      startDate: null,
      daysAgo: null,
      earnedSnaps: null,
      nextDate: null,
    };
  },
  mounted() {
    console.log("startDate", this.date);
    //const startDate = new Date(this.date.replace(/-/g, "/"));
    const startDate = new Date(this.date.date);
    const nextDate = addDays(startDate, 30);

    const options = { year: "numeric", month: "long", day: "numeric" };
    this.startDate = startDate.toLocaleDateString("en-US", options);
    this.nextDate = nextDate.toLocaleDateString("en-US", options);

    // console.log("startDate", startDate, this.date);

    const nowDate = new Date();
    const daysAgo = Math.floor((nowDate - startDate) / 86400000);
    const intervalsAgo = Math.floor(daysAgo / 30);
    this.earnedSnaps = intervalsAgo * 5000;
    this.daysAgo = daysAgo;
  },
  methods: {
    async clickExit() {
      const response = await Back.exitHeadsDown();
      // console.log("exit response", response);

      this.$toasted.show(
        "You've exited Heads Down mode and earned " +
          this.earnedSnaps +
          " snaps",
        {
          icon: "check",
          position: "bottom-center",
          duration: 2000,
        }
      );

      setTimeout(function () {
        location.reload();
      }, 2500);
    },
  },
};

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
</script>

<style lang="scss" scoped>
.heads-down {
  max-width: 710px;
  background: lighten(#ffe8c6, 8%);
  border: 2px solid #ffe8c6;
  margin-top: 20px;
  border-radius: 20px;
  padding: 16px 22px;
  font-size: 12pt;
  font-weight: 500;
  font-family: "Source Sans Pro";

  .breakdown {
    background: #fff;
    margin: 12px 0;
    border: 1px solid darken(#ffe8c6, 10%);
    // border-left: 0;
    // border-right: 0;
    border-radius: 8px;
    padding: 12px;
  }
  .breakdown-line {
    clear: both;
    border-bottom: 1px solid lighten(#ffe8c6, 2%);
  }
  .breakdown-label {
    float: left;
    width: 180px;
    color: $color-blue;
    font-weight: 600;
  }
  .breakdown-value {
    float: left;
    width: 240px;
  }

  .leave-button {
  }
  .leave-button-more {
    font-size: 11pt;
    padding: 4px;
  }
}
</style>